import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const ProviderViewModal = ({
  isOpen,
  onClose,
  workshop,
  language,
  onEdit,
  onDelete
}) => {
  if (!isOpen || !workshop) return null;

  const labels = {
    title: { en: 'Emergency Details', ar: 'تفاصيل ورشة الطوارئ' },
    name: { en: 'Name', ar: 'الاسم' },
    description: { en: 'Description', ar: 'الوصف' },
    phone: { en: 'Phone Number', ar: 'رقم الهاتف' },
    images: { en: 'Images', ar: 'الصور' },
    location: { en: 'Location', ar: 'الموقع' },
    coordinates: { en: 'GPS Coordinates', ar: 'إحداثيات GPS' },
    tags: { en: 'Services', ar: 'الخدمات' },
    emergency: { en: 'Emergency Service', ar: 'خدمة الطوارئ' },
    yes: { en: 'Available', ar: 'متوفر' },
    no: { en: 'Not Available', ar: 'غير متوفر' },
    edit: { en: 'Edit', ar: 'تعديل' },
    delete: { en: 'Delete', ar: 'حذف' }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow border w-full max-w-2xl max-h-[90vh] overflow-y-auto">

        {/* Header */}
        <div className="sticky top-0 bg-card border-b px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">
            {labels.title[language]}
          </h2>
          <button onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-5">

          {/* Name */}
          <div>
            <label className="text-sm text-muted-foreground">
              {labels.name[language]}
            </label>
            <p className="font-semibold text-lg">
              {workshop?.name}
            </p>
          </div>

          {/* Description */}
          <div>
            <label className="text-sm text-muted-foreground">
              {labels.description[language]}
            </label>
            <p className="text-base leading-relaxed">
              {workshop?.description}
            </p>
          </div>

          {/* Phone */}
          <div>
            <label className="text-sm text-muted-foreground">
              {labels.phone[language]}
            </label>
            <div className="flex items-center gap-2 mt-1">
              <Icon name="Phone" size={16} />
              <p>{workshop?.phone_number}</p>
            </div>
          </div>

          {/* Images */}
          {workshop?.images?.length > 0 && (
            <div>
              <label className="text-sm text-muted-foreground block mb-2">
                {labels.images[language]}
              </label>
              <div className="grid grid-cols-3 gap-3">
                {workshop.images.map((img, i) => (
                  <Image
                    key={i}
                    src={img?.media_link}
                    alt="workshop"
                    className="h-24 w-full object-cover rounded-lg"
                  />
                ))}
              </div>
            </div>
          )}

          {/* Location */}
          <div>
            <label className="text-sm text-muted-foreground">
              {labels.location[language]}
            </label>
            <div className="flex items-start gap-2 mt-1">
              <Icon name="MapPin" size={16} />
              <p>{workshop?.address || '—'}</p>
            </div>
          </div>

          {/* Coordinates */}
          <div>
            <label className="text-sm text-muted-foreground">
              {labels.coordinates[language]}
            </label>
            <p className="mt-1">
              {workshop?.latitude}, {workshop?.longitude}
            </p>
          </div>

          {/* Emergency */}
          <div>
            <label className="text-sm text-muted-foreground">
              {labels.emergency[language]}
            </label>
            <p className="mt-1">
              {workshop?.is_emergency_provided
                ? labels.yes[language]
                : labels.no[language]}
            </p>
          </div>

          {/* Tags (Services) */}
          {workshop?.tags?.length > 0 && (
            <div>
              <label className="text-sm text-muted-foreground block mb-2">
                {labels.tags[language]}
              </label>
              <div className="flex flex-wrap gap-2">
                {workshop.tags.map((tag, i) => (
                  <span
                    key={i}
                    className="px-3 py-1 rounded-full bg-primary/10 text-primary text-sm"
                  >
                    {tag.name}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-3 pt-4">
            <Button fullWidth variant="outline" onClick={onEdit} iconName="Edit2">
              {labels.edit[language]}
            </Button>
            <Button fullWidth variant="destructive" onClick={onDelete} iconName="Trash2">
              {labels.delete[language]}
            </Button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProviderViewModal;